import BaseModal from "@components/atoms/base-modal";
import { useClickOutside } from "@models/interactions/use-click-outside";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function VideoModal(props: Props) {
  const ref = useClickOutside(props.onClose);

  return (
    <BaseModal open={props.open}>
      <iframe
        ref={ref}
        width="100%"
        height="100%"
        src="https://www.youtube.com/embed/AyQM6_01P6U?modestbranding=1&rel=0&fs=0&showinfo=0&autoplay=1"
        //@ts-ignore
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        className="h-[90vh] w-[80vw]"
      />
    </BaseModal>
  );
}
